import { InputFieldProps } from "./types";

export const StringInput: React.FC<InputFieldProps> = ({ inputField, inputValue, onUpdate }) => {
	if (inputField.type !== "string") {
		return <>non-string input field types is not currently supported</>;
	}

	return (
		<div>
			{inputField.multiline ? (
				<textarea
					onChange={(e) => onUpdate?.(e.target.value)}
					value={inputValue || ""}
					rows={3}
					className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
				/>
			) : (
				<input
					onChange={(e) => onUpdate?.(e.target.value)}
					type="text"
					value={inputValue || ""}
					className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
				/>
			)}
		</div>
	);
};
